import { render, staticRenderFns } from "./WsInfoImages.vue?vue&type=template&id=ba13786c&"
import script from "./WsInfoImages.vue?vue&type=script&lang=js&"
export * from "./WsInfoImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports